"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleTypeToString = transformVehicleTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const routeGeographyFlagUtils_1 = require("../utils/routeGeographyFlagUtils");
function getVehicleNameByTypeAndRoute(vehicleType, routeGeographyFlag) {
    if (!routeGeographyFlag) {
        return;
    }
    if (vehicleType === legacy_enums_1.VehicleType.LuxurySedan) {
        switch (true) {
            case (0, routeGeographyFlagUtils_1.isMexicanRoute)(routeGeographyFlag):
                return "premium suv";
            case (0, routeGeographyFlagUtils_1.isSuvReplacingLuxurySedanRoute)(routeGeographyFlag):
                return "suv";
            case (0, routeGeographyFlagUtils_1.isCubaRoute)(routeGeographyFlag):
                return "classic cuban car";
            default:
        }
    }
}
function transformVehicleTypeToString(vehicleType, routeGeographyFlag) {
    const vehicleNameRouteSpecific = getVehicleNameByTypeAndRoute(vehicleType, routeGeographyFlag);
    if (vehicleNameRouteSpecific) {
        return vehicleNameRouteSpecific;
    }
    switch (vehicleType) {
        case legacy_enums_1.VehicleType.SedanLite:
            return "sedan-lite";
        case legacy_enums_1.VehicleType.Sedan:
            return "sedan";
        case legacy_enums_1.VehicleType.MpvLite:
            return "mpv-lite";
        case legacy_enums_1.VehicleType.Mpv:
            return "mpv";
        case legacy_enums_1.VehicleType.VanLite:
            return "van-lite";
        case legacy_enums_1.VehicleType.Van:
            return "van";
        case legacy_enums_1.VehicleType.Shuttle:
            return "shuttle";
        case legacy_enums_1.VehicleType.LuxurySedan:
            return "luxury sedan";
        default:
            return (0, utils_1.assertUnreachable)(vehicleType);
    }
}
//# sourceMappingURL=transformVehicleTypeToString.js.map